import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class GetExam extends React.Component {
  state = {
    consulta: []
  }

  componentDidMount() {
    apiProfessional.getAgent(this.props.agent_id)
      //api.get(`/agent/${this.props.agent_id}`, {headers: {'x-access-token': token}})
      .then(res => {
        const consulta = res.data;
        this.setState({ consulta });
      })
  }

  render() {
    return (
      <ul>
        {this.state.consulta.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Representante da Instituição: </p><p>{details.name}</p>
            <p id="RI-Title-Cadastro-Paciente" >Telefone do(a) Representante da Instituição: </p><p>{details.phone}</p>
            <p id="RI-Title-Cadastro-Paciente" >E-mail do(a) Representante da Instituição: </p><p>{details.email}</p>
          </>)}
      </ul>
    )
  }
}